// extracted by mini-css-extract-plugin
export default {"container":"DH_njO"};